import { useEffect } from 'react';
import { trackPageView, recordUserSession, updateSessionOnLogout } from '@/services/analyticsService';
import { useQuery } from '@tanstack/react-query';
import { getCurrentUserEmail } from '@/lib/auth';

export const useAnalytics = () => {
  let location = null;
  try {
    const { useLocation } = require('react-router-dom');
    location = useLocation();
  } catch {
    return;
  }
  
  useEffect(() => {
    if (location) {
      try { trackPageView(location.pathname); } catch {}
    }
  }, [location?.pathname]);
  
  useEffect(() => {
    try { recordUserSession(); } catch {}
  }, []);
};

export const useIsAdmin = () => {
  return useQuery({
    queryKey: ['isAdmin'],
    queryFn: async () => {
      // TODO: Wire to roles API
      const email = getCurrentUserEmail();
      return !!email; // Assume admin if logged in for now
    },
    staleTime: 60000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
